export default __webpack_public_path__ + "static/media/ic_calendar-black.7eb6fef4.svg";